"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getViewCountTargeting_1 = __importDefault(require("./getViewCountTargeting"));
var getAgeTargeting_1 = __importDefault(require("./getAgeTargeting"));
var getGenderTargeting_1 = __importDefault(require("./getGenderTargeting"));
var getRankingTargeting_1 = __importDefault(require("./getRankingTargeting"));
var getCategoryFromStory = function (story) {
    var _a;
    // if we can't find what we want, we're done here.
    if (!story || (!story.category && !Array.isArray(story.categories))) {
        return undefined;
    }
    // if we have category, use it. Otherwise, trust first item in categories
    return (_a = story.category) !== null && _a !== void 0 ? _a : story.categories[0];
};
function default_1(story, storyPart, user) {
    var rankingStatus = storyPart ? storyPart.rank : undefined;
    var category = getCategoryFromStory(story);
    var targeting = {};
    if (storyPart && storyPart.rating) {
        targeting["partRating"] = storyPart.rating;
    }
    if (story && story.rating) {
        targeting["storyRating"] = story.rating;
    }
    if (category) {
        targeting["category"] = category;
    }
    if (storyPart && storyPart.totalViewCount) {
        targeting["totalViewCount"] = (0, getViewCountTargeting_1.default)(storyPart.totalViewCount);
    }
    else if (story && story.totalViewCount) {
        targeting["totalViewCount"] = (0, getViewCountTargeting_1.default)(story.totalViewCount);
    }
    if (story && story.language) {
        targeting["language"] = story.language;
    }
    if (rankingStatus) {
        targeting["rankingStatus"] = (0, getRankingTargeting_1.default)(rankingStatus);
    }
    if (story && story.id) {
        targeting["storyId"] = story.id;
    }
    if (storyPart && storyPart.id) {
        targeting["partId"] = storyPart.id;
        targeting["tUrl"] = "https://www.wattpad.com/amp/".concat(storyPart.id);
    }
    if (user && user.gender) {
        targeting["KV1"] = (0, getGenderTargeting_1.default)(user);
        targeting["KV2"] = (0, getAgeTargeting_1.default)(user);
    }
    if (storyPart &&
        storyPart.brandSafetySource &&
        storyPart.brandSafetyLevel !== undefined) {
        targeting["brandSafetySource"] = storyPart.brandSafetySource;
        targeting["brandSafetyLevel"] = storyPart.brandSafetyLevel;
    }
    return targeting;
}
exports.default = default_1;
